import { isDark } from '../utils/colors';
import { capitalizeFirstLetter } from '../utils/strings';
import { getIntegrationCategory } from '../utils/app';

export function computeColorsMetadata(config) {
    [
        {
            key: 'brandColor',
            isDefaultDark: true,
        },
        {
            key: 'accentColor',
            isDefaultDark: true,
        },
        {
            key: 'linkColor',
            isDefaultDark: true,
        },
    ].forEach(({ key, isDefaultDark }) => {
        const metadataKey = `is${capitalizeFirstLetter(key)}Dark`;

        if (config[key]) {
            try {
                config[metadataKey] = isDark(`#${config[key]}`);
            } catch (e) {
                console.warn(`Invalid value for ${key}`);
                config[metadataKey] = isDefaultDark;
            }
        } else {
            config[metadataKey] = isDefaultDark;
        }
    });

    return config;
}

/*
This will filter the integration list to keep only one of each category and move their specific type to a subtype.
This is useful for when an app has multiple email integrations for instance.
*/
export function filterIntegrations(integrations) {
    const { list } = integrations.reduce(
        ({ list, hasEmailIntegration }, integration) => {
            const category = getIntegrationCategory(integration.type);
            if (getIntegrationCategory(integration.type) === 'email' && !hasEmailIntegration) {
                return {
                    list: [
                        ...list,
                        {
                            ...integration,
                            category,
                        },
                    ],
                    hasEmailIntegration: true,
                };
            }

            return {
                list: [
                    ...list,
                    {
                        ...integration,
                        category,
                    },
                ],
                hasEmailIntegration,
            };
        },
        {
            list: [],
            hasEmailIntegration: false,
        },
    );

    return list;
}
